<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
    created() {
      this.$store.commit('CHANGE_WINDOWS_SIZE', window.innerWidth)
      
      window.addEventListener('resize', () => {
        this.$store.commit('CHANGE_WINDOWS_SIZE', window.innerWidth)
      }
    )}
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0 !important;
  font-family: "Avenir" !important;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

</style>
